import { useQuery } from 'react-query';

import {
  SubscriberDirectoryParams,
  SubscriberDirectoryResponse,
  getSubscriberDirectory,
} from '../utils/backend-api/subscriber_directory';

export const SUBSCRIBERS_KEY = 'SUBSCRIBERS_KEY';

export default function useSubscriberDirectory(values: SubscriberDirectoryParams) {
  const { data: subscribersData, isLoading: isLoadingSubscriberDirectory } =
    useQuery<SubscriberDirectoryResponse>(
      [SUBSCRIBERS_KEY, values],
      async () => await getSubscriberDirectory(values),
      { keepPreviousData: true }
    );

  return {
    subscribersData,
    isLoadingSubscriberDirectory,
  };
}
